// extracted by mini-css-extract-plugin
module.exports = {"DocumentPane":"styles-module--DocumentPane--3pjYJ"};